import request from '@/request';

export function getFormConfig({ formKey, domain }, { onSuccess = () => {} } = {}) {
	request({
		url: `https://${domain}/survey/public/json-config?key=${formKey}`,
		cachePath: formKey,
		shouldCache: () => true,
		onSuccess,
	});
}
